import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { trackScreenViewed } from './analyticsClient'
import type { AnalyticsScreenName } from './analyticsTypes'

function resolveScreenName(pathname: string): AnalyticsScreenName {
  if (pathname === '/' || pathname === '/index.html') return 'home'
  if (pathname === '/app') return 'welcome'
  if (pathname.startsWith('/app/sentinel')) return 'sentinel'
  if (pathname.startsWith('/app/ai')) return 'ai_chat'
  if (pathname.startsWith('/app/insights')) return 'insight_list'
  if (pathname.startsWith('/app/map')) return 'map'
  if (pathname.startsWith('/app/report')) return 'report'
  if (pathname.startsWith('/app/searchLegalEntity')) return 'legal_entity_search'
  if (pathname.startsWith('/app/analytical-library')) return 'study_list'
  if (pathname.startsWith('/app/options/notifications')) return 'notifications'
  if (pathname.startsWith('/app/options')) return 'options'
  if (pathname.startsWith('/app/time-series')) return 'time_series'
  if (pathname.startsWith('/app/explorer')) return 'explorer'
  if (pathname.startsWith('/app/agent-report')) return 'agent_report'
  return 'unknown'
}

export default function AnalyticsScreenTracker() {
  const location = useLocation()
  const previousScreenRef = useRef<AnalyticsScreenName | null>(null)

  useEffect(() => {
    const screen = resolveScreenName(location.pathname)
    if (previousScreenRef.current === screen) {
      return
    }

    trackScreenViewed(screen, {
      source_screen: previousScreenRef.current ?? undefined,
    })
    previousScreenRef.current = screen
  }, [location.pathname])

  return null
}
